<div class="white-bg">
    <breadcrumbs>
        <breadcrumb route="/" label="Dashboard"></breadcrumb>
        <breadcrumb route="/inspection" label="Find Inspection"></breadcrumb>
        <breadcrumb [currentRoute]="true" label="{{InspectionEquipment.Equipment.MakeModelFamily.Family.Title}} "></breadcrumb>
    </breadcrumbs>
    <div class="content">
        <div class="overview">
            <overview-image [src]="getImage(InspectionEquipment.Equipment.EquipmentPhoto)" [equipmentId]="InspectionEquipment.Equipment.Id" [image]="InspectionEquipment.Equipment.EquipmentPhoto"
             (eventClick)="changeEvalInChildClicked($event)" [eval]="InspectionEquipment.Eval.EvalCode" evalBackground="{{InspectionEquipment.Eval.EvalCode | lowercase}}"  
             (loadImage)="updateImage($event)"
             [loading]="LoadingStatus(1)"></overview-image>

            <div class="overview__content">
              <div class="content__primary">
                <item-group>
                  <item label="Serial Number" [primary]="true" [loading]="LoadingStatus(1)"><a routerLink="/equipment/{{InspectionEquipment.Equipment.Id}}" matTooltip="Manage equipment">{{InspectionEquipment.Equipment.Serial}}</a></item>
                  <item label="Unit Number" [primary]="true" [loading]="LoadingStatus(1)"><a routerLink="/equipment/{{InspectionEquipment.Equipment.Id}}" matTooltip="Manage equipment">{{InspectionEquipment.Equipment.Unit}}</a></item>
                </item-group>
                <div>

                  <button mat-raised-button color="warn" (click)="openReportConfigurations()">{{translate('Report Configurations')}}</button>&nbsp;&nbsp;
                  <button mat-raised-button color="warn" [disabled]="downloadingPDF" [class.loading]="downloadingPDF" (click)="downloadPDF()">{{translate('PDF')}}<i class="material-icons">save_alt</i></button>&nbsp;&nbsp;
                  <button mat-raised-button color="warn" (click)="prepareReport()" style="display: none;">Prepare Report</button>
                  <button *ngIf="IsReleased" mat-raised-button color="warn" (click)="sendReport()" style="display: none;"><span class="button__text">Send Report</span></button>&nbsp;&nbsp;
                  <button *ngIf="!IsReleased" mat-raised-button color="warn" [disabled]="downloadingPDF" [class.loading]="downloadingPDF" (click)="ReleaseReport()" [matTooltip]="translate('Release Report to Customer')"><span class="button__text">{{translate('Release')}}</span></button>
                </div>
              </div>
                <div class="content__secondary">
                    <item-group>
                        <item label="Customer" [loading]="LoadingStatus(1)">{{InspectionEquipment.Equipment.Customer.Title}}</item>
                        <item label="JobSite" [loading]="LoadingStatus(1)">{{InspectionEquipment.Equipment.JobSite.Title}}</item>
                        <item label="Make" [loading]="LoadingStatus(1)">{{InspectionEquipment.Equipment.MakeModelFamily.Make.Title}}</item>
                        <item label="Model" [loading]="LoadingStatus(1)">{{InspectionEquipment.Equipment.MakeModelFamily.Model.Title}}</item>
                        <item label="Family" [loading]="LoadingStatus(1)">{{InspectionEquipment.Equipment.MakeModelFamily.Family.Title}}</item>
                        <item label="Inspection Date" [loading]="LoadingStatus(1)">{{_generalInspection.Date | date}}</item>
                        <item label="Inspector" [loading]="LoadingStatus(1)">
                            <!-- {{InspectionEquipment.Inspector.Name}} -->

                        <div class="component-container" >
                            <div matToolip="Change Inspector" disabled="!isInterpreter" [matMenuTriggerFor]="changeInspector" class="text-container" title="Click to edit">
                              <span class="text-container__text"> {{InspectionEquipment.Inspector.Name}} </span>
                              <i class="material-icons text-container__edit">edit</i>
                            </div>

                            <mat-menu #changeInspector="matMenu">
                                <button mat-menu-item  *ngFor="let inspector of availableInspectors"  (click)= "changedInspector(inspector)" >{{inspector.UserName}}</button>
                              </mat-menu>
                          </div>

                    </item>
                    <item label="Inspection Id" [loading]="LoadingStatus(1)">{{InspectionEquipment.InspectionId}}</item>

                    </item-group>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="tabs tabs--max-width" style="max-width: none !important;">
    <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="LoadTabGeneral()" style="max-width: none !important;">
        <mat-tab label="GENERAL">
            <div class="center" *ngIf="LoadingStatus(2)">
                <mat-spinner></mat-spinner>
            </div>
            <div *ngIf="selectedTab == 0 && !LoadingStatus(2)" [@fadeIn]>
                <panel class="margin-top-24">
                    <div style="display: flex;">
                        <div>
                            <div class="form-item">
                                <label class="form-label">Date</label>
                                <div class="form-input" (click)="picker.open()">
                                    <input class="form-input-date" matInput [matDatepicker]="picker" placeholder="Choose a date" [(ngModel)]="_generalInspection.Date"max="{{ todate | date:'yyyy-MM-dd'}}" [formControl]="date" min="{{InspectionEquipment.Equipment.SetupDate| date:'yyyy-MM-dd'}}">
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            <div class="form-item">
                                <label class="form-label" for="smu">Meter Reading (SMU/Hourmeter)</label>
                                <div class="form-input">
                                    <input matInput name="smu" value="0" [(ngModel)]="_generalInspection.SMU">
                                    <!--<edit-data inputId="smu" dataType="number" [canEdit]="true" [(value)]="meterReading" [loading]="loadingOverview"></edit-data>-->
                                    <mat-error *ngIf="_generalInspection.SMUValidationFailed">
                                        {{_generalInspection.SMUMessage}}
                                    </mat-error>
                                </div>
                            </div>
                           
                                <div class="form-item">
                                    <label class="form-label">Inspection Type</label>
                                    <mat-form-field class="input">
                                      <mat-select [disabled]="!isAdmin" style="align-content: center" (selectionChange)="InspectionTypeChange()"  [(ngModel)]="_generalInspection.InspectionType"
                                        placeholder="{{Translate('Inspection Type')}}">
                                        <mat-option  [value]="0">Full Inspection</mat-option>
                                        <mat-option *ngFor="let type of inspectionTypesList" [value]="type.Id">
                                          {{ type.Name }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
        
                        </div>
                        <div>
                            <div class="form-item">
                                <label class="form-label" for="InterpretationComment">Interpretation Comment</label>
                                <div class="form-input" style="width: 650px;">
                                    <edit-data  aria-placeholder="Enter the Interpretation Comment" [loading]="loadingOverview" inputId="InterpretationComment" dataType="textarea" [canEdit]="true" [(value)]="_generalInspection.InterpComment" (valueChanged)="updateInterpComment($event)"></edit-data>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                          
                   
                    <div class="form-item">
                        <button mat-raised-button color="primary" [class.loading]="isSaving" (click)="submitSMU()">{{Translate('Save')}}</button>
                        <!-- <button mat-raised-button color="primary" [class.loading]="isSaving" (click)="recalculateWorn()">{{Translate('Recalculate & Save')}}</button> -->
                    </div>
                   
                </panel>
                <panel class="margin-top-24">
                    <div class="form-item">
                        <label class="form-label" for="tramming">Tramming/Propel Hours</label>
                        <div class="form-input">
                            <edit-data inputId="tramming" dataType="number" [canEdit]="true" [(value)]="_generalInspection.TrammingHours" [loading]="loadingOverview" (valueChanged)="updateTrammingHours($event)"></edit-data>
                        </div>
                    </div>
                    <div class="form-item">
                      <label class="form-label" for="noShoesLeft">Number Of Shoes Left</label>
                      <div class="form-input">
                        <edit-data inputId="tramming" dataType="number" [canEdit]="true" [(value)]="_generalInspection.ShoeCountLeft" [loading]="loadingOverview" (valueChanged)="updateNumberOfShoesLeft($event)"></edit-data>

                        <!-- {{_generalInspection.ShoeCountLeft}} -->
                      </div>

                  </div>

                  <div  class="form-item">
                    <label class="form-label"  for="noShoesRight">Number Of Shoes Right</label>
                    <div class="form-input">
                        <edit-data inputId="tramming" dataType="number" [canEdit]="true" [(value)]="_generalInspection.ShoeCountRight" [loading]="loadingOverview" (valueChanged)="updateNumberOfShoesRight($event)"></edit-data>

                      <!-- {{_generalInspection.ShoeCountRight}} -->
                    </div>
                  </div>

                    <div class="form-item">
                        <label class="form-label" for="customerContact">Customer Contact</label>
                        <div class="form-input">
                            <edit-data inputId="customerContact" [canEdit]="true" [(value)]="_generalInspection.CustomerContact" [loading]="loadingOverview" (valueChanged)="updateCustomerContact($event)"></edit-data>
                        </div>
                    </div>
                    <div class="form-item">
                        <label class="form-label" for="generalInspectionNotes">General Inspection Notes</label>
                        <div class="form-input">
                            <edit-data [loading]="loadingOverview" inputId="generalInspectionNotes" dataType="textarea" [canEdit]="true" [(value)]="_generalInspection.InspectionNotes" (valueChanged)="updateGeneralInspectionNotes($event)"></edit-data>
                        </div>
                    </div>
                </panel>
                <panel  class="margin-top-24" *ngIf="!LoadingStatus(2)">
                    <div class="form-item">
                        <label class="form-label" title="Impact is best described as the amount of grouser penetration in the ground.">Impact</label>
                        <div class="form-input">
                            <mat-radio-group [(ngModel)]="_generalInspection.Impact" (change)="updateImpact($event.value)">
                                <mat-radio-button [value]="0" title=" Completely penetrable surfaces where grouser bar penetrates earth completely.">Low</mat-radio-button>
                                <mat-radio-button [value]="1" title="Partially penetrable surfaces with constant exposure to smaller bumps.">Medium</mat-radio-button>
                                <mat-radio-button [value]="2" title="Non-penetrable hard surfaces with constant exposure to 15 to 20cm or higher rocks.">High</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="form-item">
                        <label class="form-label" title="Moisture plays a big role in defining abrasiveness.">Abrasive</label>
                        <div class="form-input">
                            <mat-radio-group [(ngModel)]="_generalInspection.Abrasive" (change)="updateAbrasive($event.value)">
                                <mat-radio-button [value]="0" title="Dry soils or rock containing a low proportion of hard, angular sharp sand or rock chip particles.">Low</mat-radio-button>
                                <mat-radio-button [value]="1" title="Damp soils containing a low proportion of hard, angular or sharp particles.">Medium</mat-radio-button>
                                <mat-radio-button [value]="2" title="Saturated wet soils containing a majority of hard, angular or sharp sand particles.">High</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="form-item">
                        <label class="form-label" title="How wet the ground environment is.">Moisture</label>
                        <div class="form-input">
                            <mat-radio-group [(ngModel)]="_generalInspection.Moisture" (change)="updateMoisture($event.value)">
                                <mat-radio-button [value]="0" title="Dry ground.">Low</mat-radio-button>
                                <mat-radio-button [value]="1" title="Moderate ground water visible.">Medium</mat-radio-button>
                                <mat-radio-button [value]="2" title="Very wet.">High</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="form-item">
                        <label class="form-label" title=" This is where material in which the machine is operating sticks to the components or between the components.">Packing</label>
                        <div class="form-input">
                            <mat-radio-group [(ngModel)]="_generalInspection.Packing" (change)="updatePacking($event.value)">
                                <mat-radio-button [value]="0" title="Dry material that does not build up around components.">Low</mat-radio-button>
                                <mat-radio-button [value]="1" title="Mud that builds up around the components.">Medium</mat-radio-button>
                                <mat-radio-button [value]="2" title="Thick heavy mud that also holds larger gravel and small rocks.">High</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="form-item">
                        <label class="form-label" for="jobsiteComments">Overall Jobsite Comment</label>
                        <div class="form-input">
                            <edit-data [loading]="loadingOverview" inputId="jobsiteComments" dataType="textarea" [canEdit]="true" [(value)]="_generalInspection.JobSiteNotes" (valueChanged)="updateJobsiteComment($event)"></edit-data>
                        </div>
                    </div>
                </panel>
            </div>
        </mat-tab>
        <mat-tab label="EQUIPMENT PHOTOS">
            <div class="margin-top-24" *ngIf="selectedTab == 1">
                <equipment-photos [inspectionId]="_generalInspection.Id"></equipment-photos>
            </div>
        </mat-tab>
        <mat-tab *ngFor="let compartType of InspectionEquipment.CompartTypes; let i = index" label="{{Translate(compartType.Title | lnhCompartName)}}">
            <div class="component-grid" *ngIf="selectedTab == i + 2">
                <div class="additional-records-l">
                    <additional-records side="Left" [inspectionId]="_generalInspection.Id" [compartTypeId]="compartType.Id"></additional-records>
                </div>
                <div class="additional-records-r">
                    <additional-records side="Right" [inspectionId]="_generalInspection.Id" [compartTypeId]="compartType.Id"></additional-records>
                </div>
                <div class="mandatory-photos-l">
                    <mandatory-component-photos [inspectionId]="_generalInspection.Id" [compartTypeId]="compartType.Id" side="Left"></mandatory-component-photos>
                </div>
                <div class="mandatory-photos-r">
                    <mandatory-component-photos [inspectionId]="_generalInspection.Id" [compartTypeId]="compartType.Id" side="Right"></mandatory-component-photos>
                </div>
                <div class="components" >
                    <component-measurement-table (measurementPointUpdated) = "childMeasurementPointUpdated()" [compartTypeTitle]="compartType.Title" [compartTypeId]="compartType.Id" [inspectionId]="_generalInspection.Id" side="Left" waitForOtherSide="false"></component-measurement-table>
                    <component-measurement-table (measurementPointUpdated) = "childMeasurementPointUpdated()" [compartTypeTitle]="compartType.Title" [compartTypeId]="compartType.Id" [inspectionId]="_generalInspection.Id" side="Right" waitForOtherSide="true"></component-measurement-table>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<!--
<nav mat-tab-nav-bar>
  <a mat-tab-link *ngFor="let routeLink of routeLinks; let i = index;"
     [routerLink]="routeLink.link"
     [active]="_router.url.includes(routeLink.link)"
     routerLinkActive #rla="routerLinkActive"
     (click)="activeLinkIndex = i">
    {{ Translate(routeLink.label)}}
  </a>
</nav>
<router-outlet></router-outlet>
-->
